export const SUBMIT_API = 'submitapi';
export const NEW_CUST_API = 'newcustapi';
export const EMAIL_AVAILABILITY_CHECK_API = 'emailAvailabilityCheckApi';
export const CONTINUE_API = 'continueapi';
